import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import leftArrow from "../../assets/i-left-arrow.svg";
import Dp from "../../assets/dp.png";
import BlurredImage from "../../components/BlurredImage";
const apiBase = process.env.REACT_APP_API;

const DisplayAllCourse = ({setIsLoading}) => {
  const [courses, setCourses] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Fetch data from the API when the component mounts
    const fetchCourses = async () => {
      try {
        setIsLoading(true);
        const response = await fetch(`${apiBase}/courses/all`);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        setCourses(data);
       
      } catch (err) {
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCourses();
  }, []); // Empty dependency array means this effect runs once when the component mounts

 

  return (
    <div className="flex flex-col justify-center items-center pt-20 md:pt-40 mb-28">
      <div className="flex flex-col justify-center items-center w-5/6">
        <div className="flex flex-row  w-full">
          <Link
            to="/"
            className=" hover:underline flex flex-row justify-center items-center"
          >
            <img
              src={leftArrow}
              alt="back-arrow"
              className="size-8 flex items-center justify-center  text-myBlack opacity-50"
            />
            <h1 className="font-semibold text-2xl uppercase text-center text-myBlack opacity-50 ">
              Back to home
            </h1>
          </Link>
        </div>
        <div className="mt-10 md:mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-16 md:gap-4 max-w-screen-lg ">
          {courses.map((course) => (
            <Link key={course.course_id} to={`/courses/${course.course_id}`} className=" shadow-md border border-myBlue border-opacity-10 rounded-xl flex flex-col justify-between ">
              {" "}
                {/* <div className=" shadow-lg rounded-xl flex flex-col justify-between "> */}
              {/* <Link to={`/courses/${course.course_id}`} className="flex flex-col justify-between"> */}
              <div></div>
                  <div className="px-8 pt-4 flex flex-col ">
                    <h2 className="text-myBlack font-bold text-2xl sm:text-3xl text-right">{course.title}</h2>
                    <h3 className="text-myBlue font-bold text-xl text-right">Biology | {course.batch}</h3>
                    <h3 className=" uppercase font-medium text-right text-sm text-gray-300">{course.quota}</h3>
                  </div>
                  <div className="my-4 flex flex-col px-8">

                    {/* <img src={course.dp} alt="" /> */}
                    <BlurredImage
        src={course.dp}
        alt={course.dp}
      />
                    <h1 className="font-semibold text-xl mt-4">Teachers :</h1>
                    <h3 className="font-semibold ml-4 opacity-50 ">Janith Miyuranga</h3>
                    <h3 className="font-semibold  ml-4 opacity-50 ">Nawod dilshan</h3>

                    {/* <p className="font-bold text-gray-400 text-base">Medical Student,</p>
                    <p className="font-bold text-gray-400 text-base">University of Moratuwa</p> */}
                  </div>
                  <div className="w-full  bg-myBlue hover:bg-opacity-85 rounded-b-xl px-5 py-6">
                    <h1 className="font-bold text-center text-3xl text-myWhite"> { course.price != 0 ? `LKR ${course.price}.00` : ("See More..")}</h1>
                  </div>
              {/* </Link> */}
                {/* </div> */}
            </Link> //make a card
          ))}
        </div>
      </div>
    </div>
  );
};

export default DisplayAllCourse;
